import { resolveImagePath } from '@/utils/imageResolver';

export function Hero() {
  return (
    <section className="relative">
      {/* Hero Section */}
      <div 
        className="relative min-h-[600px] bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${resolveImagePath('/images/hero-background.jpg')})`,
        }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-white">
          {/* Main Hero Content - Split Layout */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 lg:gap-12">
            {/* Left Side - Text Content */}
            <div className="lg:w-1/2">
              {/* Background Effect for Text Legibility */}
              <div className="bg-black bg-opacity-40 p-6 sm:p-8 rounded-lg">
                {/* Tagline */}
                <p className="text-xl sm:text-2xl font-medium mb-6 text-left">
                  Old-school values, modern tools.
                </p>
                
                {/* Main Description */}
                <p className="text-lg sm:text-xl mb-6 leading-relaxed text-left">
                  We're a Tulsa shop built on transparency, skill, and no-BS repairs. Whether it's 
                  diagnostics, suspension work, or a full engine replacement, we've got the tools 
                  and know-how to fix it right.
                </p>
                
                {/* Warranty Info */}
                <p className="text-lg sm:text-xl mb-0 leading-relaxed text-left">
                  We work on Domestic, Asian, and classic cars, and back it all with a 
                  3-year/36,000-mile nationwide warranty. Your car's health - and your peace 
                  of mind - are our priorities.
                </p>
              </div>
            </div>
            
            {/* Right Side - Call-to-Action Buttons */}
            <div className="lg:w-1/2 flex flex-col gap-4 lg:items-end">
              <a
                href="/appointments"
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-300 text-lg w-[280px] text-center"
              >
                Book Appointment
              </a>
              
              <a
                href="/faq"
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-300 text-lg w-[280px] text-center"
              >
                How Does This Work? FAQ
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}